<!-- fakturapp/src/shared/dialogs/ksef-error-details-dialog/ksef-error-details-dialog.component.html -->

<div class="flex flex-col h-full">
    <!-- Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
        <div class="flex items-center gap-3">
            <mat-icon 
                class="text-red-500 dark:text-red-400"
                [svgIcon]="'tabler_outline:alert-circle'"
                style="width: 32px; height: 32px; font-size: 32px;">
            </mat-icon>
            <div>
                <h2 class="text-2xl font-semibold text-gray-900 dark:text-white">
                    Szczegóły Błędu KSeF
                </h2>
                <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    Faktura: <span class="font-medium">{{ data.documentNumber }}</span>
                </p>
            </div>
        </div>
        <button 
            mat-icon-button 
            (click)="close()"
            [matTooltip]="'Zamknij'">
            <mat-icon [svgIcon]="'tabler_outline:x'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-auto p-6">
        
        <!-- Error Summary -->
        <div class="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4 mb-6">
            <div class="flex items-start gap-3">
                <div class="flex-shrink-0">
                    <div class="w-10 h-10 rounded-full bg-red-100 dark:bg-red-900 flex items-center justify-center">
                        <span class="text-red-600 dark:text-red-400 font-bold text-sm">
                            {{ getErrorCode() }}
                        </span>
                    </div>
                </div>
                <div class="flex-1 min-w-0">
                    <h3 class="text-sm font-semibold text-red-900 dark:text-red-200 mb-1">
                        Kod błędu: {{ getErrorCode() }}
                    </h3>
                    <p class="text-sm text-red-800 dark:text-red-300">
                        {{ getErrorMessage() }}
                    </p>
                </div>
            </div>
        </div>

        <!-- Suggestion Box -->
        <div *ngIf="getSuggestion()" class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-6">
            <div class="flex items-start gap-3">
                <mat-icon 
                    class="text-blue-600 dark:text-blue-400 flex-shrink-0"
                    [svgIcon]="'tabler_outline:bulb'">
                </mat-icon>
                <div>
                    <h4 class="text-sm font-semibold text-blue-900 dark:text-blue-200 mb-1">
                        Sugerowane rozwiązanie
                    </h4>
                    <p class="text-sm text-blue-800 dark:text-blue-300">
                        {{ getSuggestion() }}
                    </p>
                </div>
            </div>
        </div>

        <!-- Metadata -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                <div class="text-xs text-gray-500 dark:text-gray-400 mb-1">Data wystąpienia</div>
                <div class="text-sm font-medium text-gray-900 dark:text-white">
                    {{ data.timestamp ? (data.timestamp | date:'dd.MM.yyyy HH:mm:ss') : 'Brak danych' }}
                </div>
            </div>
            
            <div *ngIf="data.userEmail" class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                <div class="text-xs text-gray-500 dark:text-gray-400 mb-1">Użytkownik</div>
                <div class="text-sm font-medium text-gray-900 dark:text-white">
                    {{ data.userEmail }}
                </div>
            </div>
        </div>

        <!-- Tabs: Details & Raw & XML & Log Data -->
        <mat-tab-group *ngIf="hasDetails() || hasXml() || hasLogData()" class="error-details-tabs">
            
            <!-- Log Data (JSON) - PIERWSZA ZAKŁADKA -->
            <mat-tab *ngIf="hasLogData()" label="Log Data (JSON)">
                <div class="pt-4">
                    <div class="flex items-center justify-between mb-3">
                        <div class="text-sm text-gray-600 dark:text-gray-400">
                            <mat-icon 
                                class="inline-block align-middle mr-1" 
                                style="width: 16px; height: 16px; font-size: 16px;"
                                [svgIcon]="'tabler_outline:database'">
                            </mat-icon>
                            Pełne dane z logu KSeF (w tym ksefException)
                        </div>
                        <button 
                            mat-stroked-button 
                            (click)="copyLogData()"
                            [matTooltip]="'Kopiuj JSON do schowka'">
                            <mat-icon [svgIcon]="'tabler_outline:copy'"></mat-icon>
                            Kopiuj JSON
                        </button>
                    </div>
                    <div class="error-container bg-gray-900 rounded-lg border border-gray-700">
                        <textarea 
                            fakturnia-highlight
                            [code]="getLogDataString()"
                            [lang]="'json'"
                            readonly>
                        </textarea>
                    </div>
                </div>
            </mat-tab>

            <!-- Szczegóły techniczne -->
            <mat-tab *ngIf="hasDetails()" label="Szczegóły techniczne">
                <div class="pt-4">
                    <div class="error-container bg-gray-900 rounded-lg border border-gray-700">
                        <textarea 
                            fakturnia-highlight
                            [code]="getDetailsString()"
                            [lang]="'json'"
                            readonly>
                        </textarea>
                    </div>
                </div>
            </mat-tab>
            
            <!-- Raw JSON -->
            <mat-tab *ngIf="hasDetails()" label="Raw JSON">
                <div class="pt-4">
                    <div class="error-container bg-gray-900 rounded-lg border border-gray-700">
                        <textarea 
                            fakturnia-highlight
                            [code]="getRawErrorString()"
                            [lang]="'json'"
                            readonly>
                        </textarea>
                    </div>
                </div>
            </mat-tab>
            
            <!-- XML Faktury -->
            <mat-tab *ngIf="hasXml()" label="XML Faktury">
                <div class="pt-4">
                    <div class="flex items-center justify-between mb-3">
                        <div class="text-sm text-gray-600 dark:text-gray-400">
                            <mat-icon 
                                class="inline-block align-middle mr-1" 
                                style="width: 16px; height: 16px; font-size: 16px;"
                                [svgIcon]="'tabler_outline:file-code'">
                            </mat-icon>
                            Dokument XML wysłany do KSeF
                        </div>
                        <button 
                            mat-stroked-button 
                            (click)="copyXml()"
                            [matTooltip]="'Kopiuj XML do schowka'">
                            <mat-icon [svgIcon]="'tabler_outline:copy'"></mat-icon>
                            Kopiuj XML
                        </button>
                    </div>
                    <div class="xml-container bg-gray-900 rounded-lg border border-gray-700">
                        <textarea 
                            fakturnia-highlight
                            [code]="getFormattedXml()"
                            [lang]="'xml'"
                            readonly>
                        </textarea>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

    <!-- Footer -->
    <div class="flex items-center justify-end gap-3 p-6 border-t border-gray-200 dark:border-gray-700 flex-shrink-0">
        <button 
            mat-stroked-button 
            (click)="copyError()"
            [matTooltip]="'Kopiuj błąd do schowka'">
            <mat-icon [svgIcon]="'tabler_outline:copy'"></mat-icon>
            Kopiuj
        </button>
        <button 
            mat-flat-button 
            color="primary"
            (click)="close()">
            Zamknij
        </button>
    </div>
</div>

